(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sm-help-center"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sm-help-center')) {
    customElements.define('sm-help-center', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.topic = 'all';
        this.items = Array.from(this.querySelectorAll('[data-help-item]'));
        this.groups = Array.from(this.querySelectorAll('[data-help-group]'));
        this.links = Array.from(this.querySelectorAll('[data-help-topic]'));
        this.query = this.querySelector('[data-help-query]');
        this.clear = this.querySelector('[data-help-clear]');
        this.status = this.querySelector('[data-help-status]');
        this.empty = this.querySelector('[data-help-empty]');
        this.items.forEach(item => { item.searchText = this.normalize(item.textContent); });
        const search = this.querySelector('[data-help-search]');
        if (search) search.hidden = false;
        this.query?.addEventListener('input', () => {
          this.topic = 'all';
          this.filter();
        });
        this.clear?.addEventListener('click', () => {
          this.query.value = '';
          this.topic = 'all';
          this.filter();
          this.query.focus();
        });
        this.links.forEach(link => link.addEventListener('click', event => {
          event.preventDefault();
          this.selectTopic(link.dataset.helpTopic);
        }));
        this.querySelectorAll('[data-help-jump]').forEach(link => link.addEventListener('click', event => {
          event.preventDefault();
          this.selectTopic(link.dataset.helpJump, false);
          this.querySelector('[data-help-group="' + link.dataset.helpJump + '"]')?.scrollIntoView({behavior:this.reducedMotion() ? 'instant' : 'smooth',block:'start'});
        }));
        this.onBlockSelect = event => {
          const block = this.items.find(item => item.dataset.helpBlock === event.detail.blockId);
          if (!block) return;
          this.selectTopic(block.dataset.helpCategory, false);
          block.open = true;
          block.scrollIntoView({block:'center',behavior:'instant'});
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }
      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.initialized = false;
      }
      normalize(text) {
        return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().replace(/\s+/g,' ').trim();
      }
      reducedMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }
      selectTopic(topic, animate = true) {
        this.topic = topic;
        if (this.query) this.query.value = '';
        const update = () => this.filter();
        if (animate && document.startViewTransition && !this.reducedMotion()) document.startViewTransition(update);
        else update();
      }
      filter() {
        const term = this.normalize(this.query?.value || '');
        const words = term.split(' ').filter(Boolean);
        let count = 0;
        this.items.forEach(item => {
          const topicMatches = this.topic === 'all' || item.dataset.helpCategory === this.topic;
          const textMatches = words.every(word => item.searchText.includes(word));
          item.hidden = !(topicMatches && textMatches);
          if (!item.hidden) count++;
        });
        this.groups.forEach(group => {
          group.hidden = !Array.from(group.querySelectorAll('[data-help-item]')).some(item => !item.hidden);
        });
        this.links.forEach(link => {
          if (link.dataset.helpTopic === this.topic) link.setAttribute('aria-current','true');
          else link.removeAttribute('aria-current');
        });
        this.status.textContent = this.dataset.resultsPattern.replace('__COUNT__', String(count));
        this.status.hidden = !term;
        if (this.clear) this.clear.hidden = !term;
        this.empty.hidden = count > 0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-set-information"]) return;
  try {
    
  if (!customElements.get('sm-set-information')) {
    customElements.define('sm-set-information', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const tabs = [...this.querySelectorAll('[role="tab"]')];
        const panels = [...this.querySelectorAll('[data-info-panel]')];
        const select = index => {
          tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(index === i)); tab.tabIndex = index === i ? 0 : -1; });
          panels.forEach((panel, i) => { panel.hidden = index !== i; });
        };
        panels.forEach((panel, i) => { panel.setAttribute('role', 'tabpanel'); panel.setAttribute('aria-labelledby', tabs[i].id); panel.tabIndex = 0; });
        tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => select(i));
          tab.addEventListener('keydown', event => {
            let target;
            if (event.key === 'ArrowRight') target = (i + 1) % tabs.length;
            if (event.key === 'ArrowLeft') target = (i + tabs.length - 1) % tabs.length;
            if (event.key === 'Home') target = 0;
            if (event.key === 'End') target = tabs.length - 1;
            if (target === undefined) return;
            event.preventDefault(); select(target); tabs[target].focus();
          });
        });
        this.querySelector('[role="tablist"]').hidden = false;
        select(0);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-set-product"]) return;
  try {
    
  if (!customElements.get('sm-set-product-detail')) {
    customElements.define('sm-set-product-detail', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        const dataNode = this.querySelector('[data-set-data]');
        if (!dataNode) return;
        this.data = JSON.parse(dataNode.textContent);
        this.initialized = true;
        this.groups = [...this.querySelectorAll('[data-option-index]')];
        this.variantInput = this.querySelector('[data-variant-id]');
        this.button = this.querySelector('[data-add-button]');
        this.querySelector('[data-size-panel]').hidden = false;
        this.button.hidden = false;
        this.addEventListener('change', (event) => {
          if (event.target.matches('.smset-size-item input')) this.updateSelection(true);
        });
        this.querySelector('form').addEventListener('submit', (event) => {
          if (this.button.disabled || this.variantInput.disabled) event.preventDefault();
        });
        const slides = [...this.querySelectorAll('[data-gallery-slide]')];
        const thumbs = [...this.querySelectorAll('[data-gallery-thumb]')];
        let activeImage = 0;
        const showImage = (index) => {
          activeImage = (index + slides.length) % slides.length;
          slides.forEach((slide, i) => { slide.hidden = i !== activeImage; });
          thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === activeImage)));
          const counter = this.querySelector('[data-gallery-count]');
          if (counter) counter.textContent = `${activeImage + 1} / ${slides.length}`;
        };
        this.querySelectorAll('[data-gallery-controls]').forEach(node => { node.hidden = false; });
        this.addEventListener('click', event => {
          const thumb = event.target.closest('[data-gallery-thumb]');
          if (thumb) showImage(Number(thumb.dataset.galleryThumb));
          if (event.target.closest('[data-gallery-prev]')) showImage(activeImage - 1);
          if (event.target.closest('[data-gallery-next]')) showImage(activeImage + 1);
        });
        let touchStart = null;
        const hero = this.querySelector('.smset-hero');
        hero.addEventListener('touchstart', event => {
          if (event.touches.length === 1) touchStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };
        }, { passive: true });
        hero.addEventListener('touchend', event => {
          if (!touchStart || !event.changedTouches.length) return;
          const dx = event.changedTouches[0].clientX - touchStart.x;
          const dy = event.changedTouches[0].clientY - touchStart.y;
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) showImage(activeImage + (dx < 0 ? 1 : -1));
          touchStart = null;
        }, { passive: true });

        this.updateSelection(false);
      }
      updateSelection(updateUrl) {
        const selected = this.groups.map((group) => {
          const input = group.querySelector('input:checked');
          group.querySelector('[data-chosen-size]').textContent = input ? input.value : this.data.labels.size;
          return input && input.value;
        });
        const complete = selected.every(Boolean);
        const variant = complete && this.data.variants.find((item) => item.options.every((value, index) => value === selected[index]));
        this.variantInput.disabled = !variant || !variant.available;
        this.button.disabled = !variant || !variant.available;
        this.button.textContent = !complete ? this.data.labels.choose : !variant ? this.data.labels.unavailable : variant.available ? this.data.labels.add : this.data.labels.soldOut;
        this.querySelector('[data-selection-status]').textContent = complete && (!variant || !variant.available) ? this.data.labels.unavailable : '';
        const shipping = this.querySelector('[data-set-shipping]');
        if (shipping) {
          shipping.hidden = !this.data.variants.some(item => item.available) || (complete && (!variant || !variant.available));
          const dispatchRank = complete && variant ? variant.dispatchRank : this.data.shippingDefaultRank;
          shipping.querySelector('[data-shipping-text]').innerHTML = this.data.shippingLabels[dispatchRank] || this.data.shippingLabels[3];
          shipping.classList.toggle('smset-dispatch-fast', dispatchRank === 1);
        }
        if (variant) {
          this.variantInput.value = variant.id;
          this.querySelector('[data-set-price]').textContent = variant.price;
          this.querySelector('[data-compare-price]').textContent = variant.compare;
          this.querySelector('[data-compare-price]').hidden = !variant.hasCompare;
          this.querySelector('[data-saving-amount]').textContent = variant.saving;
          this.querySelector('[data-savings]').hidden = !variant.hasSaving;
          if (updateUrl) {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url);
          }
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
